


















































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app'
import TimesheetDto from '@/models/Timesheets/TimesheetDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import PageNames from '@/router/PageNames';
import TimesheetStatus from '@/components/Timesheets/Display/TimesheetStatus.vue';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue'

@Component({
  name: 'WorkerShifts',
  components: { TimesheetStatus, BookingRoleWorkerShiftStatus }
})
export default class extends GiganautVue {
    
    async created() {
       await WorkerDetailsModule.getShifts();
    }

    async navigateToBooking(item: TimesheetDto) {
        const bookingId = item.bookingId;
        this.$router.push({ name: PageNames.AgencyBookingDetails, params: { bookingid: bookingId } });
    }
    
    get loading() {
        return WorkerDetailsModule.loadingShifts;
    }

    get shifts() {
        return WorkerDetailsModule.shifts;
    }

    private headers = [
        { text: '' },
        { text: AppModule.currentAgencyContext.labels.location, value: 'location.brandName'},
        { text: 'Position', value: 'shift.bookingRole.position.name' },
        { text: 'Pay Rate', value: 'payRate' },
        { text: 'Charge Rate', value: 'shift.bookingRole.chargeRate' },
        { text: 'Booking Ref', value: 'booking.sequenceNumber' },
        { text: 'Date', value: 'startAt' },
        { text: 'Start', value: 'startAt' },
        { text: 'End', value: 'endAt' },
        { text: 'Booking Status', value: 'status' },
        { text: 'Timesheet Status', value: 'status' },       
    ]
}
